import { render, staticRenderFns } from "./Locate.vue?vue&type=template&id=98153452"
import script from "./Locate.vue?vue&type=script&lang=js"
export * from "./Locate.vue?vue&type=script&lang=js"
import style0 from "./Locate.vue?vue&type=style&index=0&id=98153452&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports